<template>

  <mw-dialog  size="small_small" :appendToBody="false" :footerButton="footerButton" ref="dialog" :title="$lang('选择用户')">

    <el-col :span="12">
       <mw-tree :url="deptTreeUrl" @dataFilter="treeDataFilter"
              :async="true" :expandedFirst="true" :defaultParams="defaultTreeParams"
              :multiple="false" class="mw-dialog-body" @changed="changed" :aliasId="treeAliasId"></mw-tree>
    </el-col>

     <el-col :span="12">

        <mw-table ref="dataTable"  :columns="columns" :defaultParamsAutoLoad="true"
                  :autoLoad="false" :pagination="false" :defaultParams="defaultParams"
                  :api="api" :singleSelect="true">
        </mw-table>
    </el-col>

 </mw-dialog>

</template>

<script>
    import { mapGetters } from 'vuex'
    export default {
        props: {
          params: {
            type: Object
          }
        },
        data() {
            return {
              deptTreeUrl: this.mwUrl('/api/org/getDepartmentTree'),
              api: 'org.listUser',
              footerButton: [{
                label: $lang('确定'),
                func: this.save
              }],
              defaultParams: {},
              //defaultTreeParams:{},
              treeAliasId:'departmentId',
              columns: [{type: 'selection'},{type: 'index'},
              {prop: 'name',label: $lang('名称'),tooltip: true}]
            }
        },

       mounted() {
         setTimeout(()=>{
           this.show();
         },200)
         //this.defaultTreeParams = {rootId:this.expUser.dep.loginUnit.id};
       },
        computed: {
          ...mapGetters([
            'expUser'
          ]),
          defaultTreeParams(){
             let result = {rootId:this.expUser.dep.loginUnit.id}
             if (!(this.userInfo && this.userInfo.developer)) result.listAble = true;
             return result;
          }
        },
      /*watch:{
        'expUser.dep.loginUnit.id'(){
          this.defaultTreeParams = {rootId:this.expUser.dep.loginUnit.id};
        }
      },*/

       methods:{

        changed(data){
          this.refreshTableDefaultParams({ departmentId : data.id});
        },

        refreshTableDefaultParams(params) {
          this.defaultParams=params;
        },

        save(){
          let data = this.mwRef('dataTable').getMultipleSelection();
          if(data.length < 1){
              this.mwMsg('info',$lang('请选择用户'));
              return;
          }
          let params = {};
          params.receiver={
            id: data[0].id,
            name: data[0].name
          }
          this.params.func(params);
          this.mwRef('dialog').hide();
        },
        show(){
          this.mwRef('dialog').show();
        },
       close(){
         this.mwRef('dialog').hide();
       },
       treeDataFilter(data) {
         if (data && window.$currentBrowserLanguage === 'en') {
           data.forEach(d=>d.text=d.Englishname || d.text);
         }
       }
      }
    }
</script>





// WEBPACK FOOTER //
// src/modules/index/components/public-dialog/turnto-process.vue